module.exports = __webpack_public_path__ + "static/media/BladeMail.506494b2.png";